// structuredClone
(function () {
  if (typeof window.structuredClone === 'function') return false;

  function structuredClone(data: unknown) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return JSON.parse(JSON.stringify(data));
  }

  window.structuredClone = structuredClone;
})();

// Promise.allSettled (Chrome < 76, Safari < 13)
(function () {
  if (typeof Promise.allSettled === 'function') return;

  Promise.allSettled = function allSettled<T>(promises: Iterable<PromiseLike<T> | T>) {
    return Promise.all(
      Array.from(promises).map((p) =>
        Promise.resolve(p).then(
          (value) => ({ status: 'fulfilled' as const, value }),
          (reason) => ({ reason, status: 'rejected' as const }),
        ),
      ),
    );
  };
})();
